import {
  Avatar,
  Card,
  Caret,
  ErrorCard,
  LoadingCard,
  ShopIcon,
} from '@odmonorepo/core-components';
import { useIntl } from 'react-intl';
import { useNavigate } from '@tanstack/react-router';
import { Col, Row, Spinner } from 'react-bootstrap';
import { getPartiesOpts, useParties, usePersons } from 'merchant-api/spiceroad';
import { useQuery } from '@tanstack/react-query';

export function InfoCard() {
  const { data: partiesData, isError: isErrorParties, isLoading: isLoadingParties } = useQuery({...getPartiesOpts,
    throwOnError: false
  });
  const { email, isLoading } = usePersons();

  const intl = useIntl();
  const navigate = useNavigate();
  const fullName = partiesData?.user?.name;
  const businessName = partiesData?.parties[0]?.businesses[0]?.legalName;

  if (isErrorParties)
    return (
      <ErrorCard name={intl.formatMessage({ id: 'loading.error.profile' })} />
    );
  if (isLoadingParties) return <LoadingCard />;

  return (
    <Card>
      <Row xs={1} sm={2} className="mb-3">
        <Col className="h2 text-dark">{fullName}</Col>
        <Col className="pt-0 pt-sm-4">
          {email}
        </Col>
      </Row>
      <Card bodyClassName="p-4" className="bg-light-gray shadow-none">
        <div
          role="button"
          onClick={() => navigate({to: '/business'})}
          className="d-flex"
        >
          <ShopIcon />
          <div className="ms-3 fs-7 d-flex align-items-center">
            {businessName}
          </div>
          <Caret className="ms-auto d-flex align-items-center" />
        </div>
      </Card>
    </Card>
  );
}

export default InfoCard;
